import { render, staticRenderFns } from "./CallsReportComp.vue?vue&type=template&id=e44ef5e6&scoped=true&"
import script from "./CallsReportComp.vue?vue&type=script&lang=js&"
export * from "./CallsReportComp.vue?vue&type=script&lang=js&"
import style0 from "./CallsReportComp.vue?vue&type=style&index=0&id=e44ef5e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44ef5e6",
  null
  
)

export default component.exports